
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[blogId]",
      function () {
        return require("private-next-pages/blog/[blogId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[blogId]"])
      });
    }
  